import "./general-settings-editor-page.scss";
import { observer } from "mobx-react";
import ListLayout from "../../../../components/layouts/list-layout/list-layout";
import EditorPageLayout from "../../../../components/layouts/editor-page/editor-page-layout";
import customizationStore from "../../../../stores/customizations/customization-store";
import { useCallback, useEffect, useState } from "react";
import useNavigationBlocker from "../../../../hooks/navigation-blocker-hook";
import { ConfirmModal } from "../../../../components/modal/components/confirm-modal/confirm-modal";
import usePage from "../../../../components/layouts/base-page-layout/page-hook";
import '../../look-and-feel.scss';
import currentPortalStore from "../../../../stores/current-portal-store";
import GeneralCard from './general-card/general-card';

import AdvancedCard from './advanced-card/advanced-card';
import PortalLayoutStyleCard from "./portal-layout-style-card/portal-layout-style-card";
import FontsAndColorsCard from "./fonts-and-colors-card/fonts-and-colors-card";


const GeneralSettingsEditorPage: React.FC = observer(() => {
    const [isShowUnsaved, setIsShowUnsaved] = useState(false);

    const { setSubTitles } = usePage();

    useEffect(() => {
        setSubTitles(['Portal', 'Look and Feel', 'General Settings']);
    }, [setSubTitles]);

    const hasChanges = () => {
        return customizationStore.hasChanges() || !!currentPortalStore.setting?.hasChanges();
    }

    const isLoading = customizationStore.isLoading || currentPortalStore.isLoading;

    const { retryNavigation, unblockNavigation } = useNavigationBlocker(
        () => hasChanges(),
        useCallback(() => setIsShowUnsaved(true), [setIsShowUnsaved])
    );

    const discardChanges = () => {
        customizationStore.discardChanges();
        currentPortalStore.setting?.discardChanges();
    }

    const onSaveClicked = () => {
        const promised = [];

        if (customizationStore.hasChanges()) {
            promised.push(
                customizationStore.save()
            );
        }

        if (currentPortalStore.setting?.hasChanges()) {
            promised.push(
                currentPortalStore.setting?.save()
            );
        }

        Promise.all(promised).then(() => {
            unblockNavigation();
        })
    }

    return (
        <>
        <EditorPageLayout toolbar={{
            hasLocalesSelector: false,
            saveButton: {
                hasChanges: hasChanges() && !isLoading,
                disabled: !hasChanges() || isLoading,
                onClick: onSaveClicked
            },
        }}>
            <ListLayout>
                <PortalLayoutStyleCard/>
                <GeneralCard/>
                <FontsAndColorsCard/>
                <AdvancedCard/>
            </ListLayout>
        </EditorPageLayout>

        {isShowUnsaved &&
            <ConfirmModal
                cancelButton={{
                    title: 'Cancel',
                    onClick: () => setIsShowUnsaved(false)
                }}
                okButton={{
                    title: 'Discard',
                    onClick: () => {
                        discardChanges();
                        setIsShowUnsaved(false);
                        retryNavigation();
                    }
                }}
            />
        }
        </>
    );
});

export default GeneralSettingsEditorPage;
